import { Pipe, PipeTransform } from '@angular/core';
import { Agent } from '../../classes/agent';

@Pipe({name: 'formatOfficeName'})
export class FormatOfficeNamePipe implements PipeTransform {
  transform(agent: Agent): any {

      // If no Agent Incorpration then return the office name
      if (!agent.agentIncorporation) return agent.officeName;


      // Agent Incorpration present and does not equal Personal Real Estate Corporation
      if (agent.agentIncorporation && agent.agentIncorporation !== 'Personal Real Estate Corporation') {
        return `${agent.firstName} ${agent.lastName}, ${agent.officeName}`
      } else {
        // otherwise, return office name
        return agent.officeName;
      }

  }
}
